import { render, staticRenderFns } from "./TerminalLearningObject.vue?vue&type=template&id=6ed236e9&"
import script from "./TerminalLearningObject.vue?vue&type=script&lang=js&"
export * from "./TerminalLearningObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports